/**
 * Guards the billing pages: a contract workspace (hidden billing) goes back to "/".
 * Waits for the billing status so the page never flashes before the redirect.
 *
 * The billing routes sit outside the workspace routes, so nothing else sets the current
 * workspace on a direct load; the provider here does, and PaymentContext then fetches its status.
 */

import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { usePayment } from "../lib/PaymentContext";
import { WorkspaceProvider, useWorkspace } from "../contexts/WorkspaceContext";

function BillingGate({ children }: { children: ReactNode }) {
  const { billingHidden, billingStatusLoaded } = usePayment();
  const { isLoading, workspaces } = useWorkspace();
  // A user with no workspace has no billing status to wait for.
  const noWorkspace = !isLoading && workspaces.length === 0;

  if (!billingStatusLoaded && !noWorkspace) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (billingHidden) return <Navigate to="/" replace />;

  return <>{children}</>;
}

export default function BillingVisibleRoute({ children }: { children: ReactNode }) {
  return (
    <WorkspaceProvider>
      <BillingGate>{children}</BillingGate>
    </WorkspaceProvider>
  );
}
